// components/video/ZoomControls.tsx
import FeatherIcon from 'feather-icons-react';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

interface ZoomControlsProps {
  zoom: number;
  minZoom?: number;
  maxZoom?: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
}

const ZoomControls: React.FC<ZoomControlsProps> = ({
  zoom,
  minZoom = 1,
  maxZoom = 5,
  onZoomIn,
  onZoomOut,
  onResetZoom
}) => {
  const zoomPercentage = Math.round(zoom * 100);
  const isMinZoom = zoom <= minZoom;
  const isMaxZoom = zoom >= maxZoom;

  return (
    <div
      className="d-flex align-items-center gap-1"
      style={{
        position: 'absolute',
        bottom: '10px',
        left: '10px',
        zIndex: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        borderRadius: '6px',
        padding: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
      }}
    >
      <ButtonGroup size="sm">
        <Button
          variant="dark"
          onClick={onZoomOut}
          disabled={isMinZoom}
          title="Diminuir zoom (Ctrl + Scroll ↓)"
          style={{
            padding: '4px 8px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            color: isMinZoom ? 'rgba(255, 255, 255, 0.3)' : 'white'
          }}
        >
          <FeatherIcon icon="zoom-out" size={14} />
        </Button>

        <Button
          variant="dark"
          onClick={onResetZoom}
          disabled={isMinZoom}
          title="Resetar zoom (Ctrl + 0)"
          style={{
            padding: '4px 12px',
            minWidth: '60px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            color: isMinZoom ? 'rgba(255, 255, 255, 0.3)' : 'white',
            fontSize: '11px',
            fontWeight: 'bold'
          }}
        >
          {zoomPercentage}%
        </Button>

        <Button
          variant="dark"
          onClick={onZoomIn}
          disabled={isMaxZoom}
          title="Aumentar zoom (Ctrl + Scroll ↑)"
          style={{
            padding: '4px 8px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            color: isMaxZoom ? 'rgba(255, 255, 255, 0.3)' : 'white'
          }}
        >
          <FeatherIcon icon="zoom-in" size={14} />
        </Button>
      </ButtonGroup>

      {zoom > 1 && (
        <small
          className="text-light ms-1"
          style={{
            fontSize: '9px',
            opacity: 0.7,
            whiteSpace: 'nowrap'
          }}
        >
          Arraste
        </small>
      )}
    </div>
  );
};

export default ZoomControls;
